import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { useCallback } from "react";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import Checkbox from "@portal/components/atoms/v2/checkbox";
import { InfoBoxComponent } from "@portal/components/atoms/infoBox";

interface Props {
  isDefaultLanguage: boolean;
  showConfirmation: boolean;
  error: string;
  isCheckboxChecked: boolean;
  setIsCheckboxChecked: (isChecked: boolean) => void;
  setPrimaryButtonDisabled: (primaryButtonDisabled: boolean) => void;
}

export const AskContent = ({
  isDefaultLanguage,
  showConfirmation,
  error,
  isCheckboxChecked,
  setIsCheckboxChecked,
  setPrimaryButtonDisabled,
}: Props) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  const OnCheckboxClick = useCallback(() => {
    setIsCheckboxChecked(!isCheckboxChecked);
    setPrimaryButtonDisabled(isCheckboxChecked);
  }, [isCheckboxChecked, setIsCheckboxChecked, setPrimaryButtonDisabled]);

  return (
    <>
      <TextLine />
      {!showConfirmation ? (
        <div className="flex pl-1">
          <Checkbox text={texts.ASK_CONFIRM} isChecked={isCheckboxChecked} onChange={OnCheckboxClick} large id="confirm" />
        </div>
      ) : (
        <InfoBoxComponent warning={!!error}>
          {error ? <Typography variant="Error">{error}</Typography> : <Typography>{texts.ASK_RECEIPT}</Typography>}
        </InfoBoxComponent>
      )}
    </>
  );
};
